export default "__VITE_ASSET__$VLaZ1IX__"